import { render, staticRenderFns } from "./PRS0000001EmailConfirmation.vue?vue&type=template&id=22c540a0&lang=pug&"
import script from "./PRS0000001EmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./PRS0000001EmailConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports